import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import Utils from "Utils/utils";
import Button from "Components/common/Button";
import DatePickerComponent from "Components/common/dateTimePicker";

export const ScheduleLaterSendEmailBtn = observer(
  ({
    sendEmailObj = {},
    isOutboxPage = false,
    enabled = false,
    scheduledDate = new Date(),
    handleDateChange = () => {}
  }) => {
    const [showDropdown, setShowDropDown] = useState(false);
    const [showOption, setShowOption] = useState("SCHEDULE_OPTION");

    const toggleScheduleLaterDropdown = () => {
      if (!isOutboxPage && enabled) {
        setShowDropDown(!showDropdown);
        showDropdown && setShowOption("SCHEDULE_OPTION");
      }
    };

    const getScheduleLaterDate = (key = "") => {
      let currentDate = new Date();
      switch (key) {
        case "ONE_HOUR":
          let timeToAdd = 1000 * 60 * 60;
          return new Date(currentDate.getTime() + timeToAdd);
        case "TOMORROW_8AM":
          currentDate.setHours(8, 0, 0, 0);
          currentDate.setDate(currentDate.getDate() + 1);
          return currentDate;
        case "TOMORROW_3PM":
          currentDate.setHours(15, 0, 0, 0);
          currentDate.setDate(currentDate.getDate() + 1);
          return currentDate;
        default:
          return currentDate;
      }
    };

    const DATE_OPTIONS = [
      {
        name: "In 1 hour",
        id: "send1HourLater",
        value: "ONE_HOUR",
        icon: "hourglass_empty"
      },
      {
        name: "Tomorrow morning, 8 AM",
        id: "sendTmrwAMorning",
        value: "TOMORROW_8AM",
        icon: "wb_sunny"
      },
      {
        name: "Tomorrow afternoon, 3 PM",
        id: "sendTmrwAfternoon",
        value: "TOMORROW_3PM",
        icon: "wb_cloudy"
      },
      {
        name: "Pick date & time",
        id: "selectNewDate",
        value: "SELECT_DATE",
        icon: "event"
      }
    ];

    const clearDropdown = () => {
      setShowOption("SCHEDULE_OPTION");
      setShowDropDown(false);
    };

    const handleSelectAction = (event = "") => {
      let value = Utils.performActionByClosestDom(event, "li", "data-key");
      if (value?.toUpperCase() === "SELECT_DATE") {
        setShowOption("SCHEDULE_DATE_PICKER");
      } else {
        let scheduleLaterDate = getScheduleLaterDate(value);
        clearDropdown();
        handleDateChange(scheduleLaterDate);
      }
    };

    useEffect(() => {
      return () => {
        clearDropdown();
      };
    }, []);

    return (
      <div className="ScheduleLaterSendEmailBtn">
        <Button {...sendEmailObj} />
        {!isOutboxPage && !sendEmailObj?.loader && (
          <div className={`scheduleLaterBtn ${!enabled ? "disabled" : ""}`}>
            <div
              className="scheduleArrowBtn"
              onClick={toggleScheduleLaterDropdown}
            >
              <i
                className={`material-icons-outlined ${
                  showDropdown ? "rotateArrow" : ""
                }`}
              >
                keyboard_arrow_down
              </i>
            </div>
            {showDropdown && (
              <div className="scheduleLaterDropdown">
                {showOption?.toUpperCase() === "SCHEDULE_OPTION" &&
                  DATE_OPTIONS?.length > 0 && (
                    <div className="selectScheduleDateOption">
                      <div className="scheduleDateHead">
                        <i className="material-icons-outlined">schedule</i>
                        <span>Schedule send</span>
                      </div>
                      <ul id="selectScheduleDateOption" onClick={handleSelectAction}>
                        {[...DATE_OPTIONS]?.map(item => {
                          const { name = "", id = "", value = "", icon = "" } =
                            item || {};
                          return (
                            <li
                              className="scheduleDateItem"
                              key={id}
                              data-key={value}
                            >
                              <i className="material-icons-outlined">{icon}</i>
                              <span className="text">{name}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                {showOption?.toUpperCase() === "SCHEDULE_DATE_PICKER" && (
                  <DatePickerComponent
                    getDateCbk={handleDateChange}
                    id="scheduleLaterDatePicker"
                    value={scheduledDate}
                    onClickOutside={clearDropdown}
                    inline={true}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
);

export default ScheduleLaterSendEmailBtn;
